<template>
    <div :visible.sync="dialogFormVisible" class="Popup">
        <el-dialog title="添加标记"   :visible.sync="dialogFormVisible" width="300px" style="margin-top:20vh">
                <el-form :model="form" size="mini">
                    <el-form-item label="名称" :label-width="formLabelWidth" style="color:white">
                    <el-input v-model="form.name" autocomplete="off" style="width:180px"></el-input>
                    </el-form-item>
                <el-aside style="width:30px; float:right; margin-top:-40px;margin-right: 30px">
                    <img :src='defaimag' style="height:30px">
                    <a href="#" @click="changima()"  style="cursor:pointer">{{iconchange}}</a>
                </el-aside>
                    <el-form-item label="备注" :label-width="formLabelWidth" style="color:white">
                    <el-input  size="mini" v-model="form.desc" autocomplete="off" style="width:180px"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer" >
                    <el-button type="primary" plain size="mini" @click="con() ">确 定</el-button>
                    <el-button  plain size="mini" type="danger" @click="delele()">取消</el-button>
                </div>
        </el-dialog>
       <el-dialog  :visible.sync="dialogVisible" height="248px" width="300px" >
            <img v-for="(item,index) in makimag" :key="index" :src="item" @click="selimg(item)" style="cursor:pointer">
       </el-dialog>
    </div>
</template>
<script>
import convertTool from '../../js/Convert';
import Bus from  '../../js/Bus'
export default {
    name:'markview',
    data () {
        return {
          dialogFormVisible:false,
          defaimag:require('../../assets/marks/mark2.png'),
          iconchange:'更换',
          form: {
            name: '',
            desc: ''
            },
           formLabelWidth: '50px',
           dialogVisible:false,
           makimag:[
               require('../../assets/marks/mark1.png'),
               require('../../assets/marks/mark2.png'),
               require('../../assets/marks/mark3.png'),
               require('../../assets/marks/mark4.png'),
            ],
              viewer:null,
              marIndex: null,
        }
    },
    methods:{
        changima () {
            var _that=this;
             _that.dialogVisible=true;
             _that.dialogFormVisible=false;
        },
        //添加名称备注
        con() {
            var makname=this.form.name;
               this.marIndex = this.$parent.labels.length - 1;
               this.$parent.labels.get(this.marIndex).text = makname;
               this.dialogFormVisible=false;
               this.form.name = "";
               this.form.desc="";
        },
        //删除图标
        delele () {
            var that =this;
            that.dialogFormVisible=false;
            var hh=that.$parent.billboards.length;
            debugger
            const index=that.$parent.billboards.length-1;
            that.$parent.billboards.remove(that.$parent.billboards.get(index));
            that.$parent.labels.remove(that.$parent.labels.get(index));
        },
        selimg(item) {
            this.defaimag=item;
            var index=this.$parent.billboards.length - 1;
            this.$parent.billboards.get(index).image=this.defaimag;
            this.dialogVisible=false;
            this.dialogFormVisible=true;
        }
    }
}
</script>
<style lang='stylus' scoped>
    .Popup >>>.el-dialog__body
       padding:0px !important;
       height:100px;
    .Popup >>>.el-form-item__content
       width:180px;
    .el-form-item
       width:310px;
    .Popup >>>.el-dialog
       background-color: rgba(0, 0, 0, 0.5);
       color:white;
    .dialog-footer
       width : 130px;
    .Popup >>>.el-dialog__title
       color:white

    .Popup >>>.el-form-item__label
       color:white
    .Popup >>>.el-dialog__footer
       float:none;
       margin-left :60px;
    .Popup >>>.el-dialog__header
       padding: 5px 20px 10px 10px;
    .Popup >>>.el-dialog__headerbtn
        position: absolute;
        top: 0px;
        right: 10px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 16px;

</style>
